import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar__logo" }
const _hoisted_3 = { class: "sidebar__nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "sidebar__bottom" }
const _hoisted_6 = { class: "sidebar__user-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "sidebar__user-list"
}
const _hoisted_8 = {
  key: 3,
  class: "block-view"
}

import IconLogo from "@/assets/icons/IconLogo.vue";
import IconDatabase from "@/assets/icons/IconDatabase.vue";
import IconGrid from "@/assets/icons/IconGrid.vue";
import IconClock from "@/assets/icons/IconClock.vue";
import IconPlus from "@/assets/icons/IconPlus.vue";
import IconUser from "@/assets/icons/IconUser.vue";
import {useRouter} from "vue-router";
import {computed, type Component, ref} from "vue";
import FilesUploadModal from "@/components/modules/FileUploadModal/FilesUploadModal.vue";
import {exit} from "@/composables/auth";
import IconLogout from "@/assets/icons/IconLogout.vue";

// Интерфейс для элементов меню навигации
interface IMenuRouteItem {
  path: string;
  name: string;
  tooltip: string;
  icon: Component;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AsidePanel',
  setup(__props) {

const router = useRouter();

// Активный роут.
const activeRouterPath = computed(() => router.currentRoute.value.fullPath);

// Список навигации
const menuRouterList: IMenuRouteItem[] = [
  {
    path: "map-view",
    name: "map-view",
    tooltip: "Карта",
    icon: IconGrid
  },
  {
    path: "event-log",
    name: "event-log",
    tooltip: "Журнал событий",
    icon: IconClock
  },
  {
    path: "database",
    name: "database",
    tooltip: "База данных",
    icon: IconDatabase
  }
];

// Переключение пунктов меню.
const changeRouteHandler = async (path: string) => {
  await router.push(path);
};

// Отображение модального окна загрузки файлов
const isShowFileUpload = ref(false);
// Переключение отображения модального окна загрузки файлов
const toggleShowFileUpload = () => {
  isShowFileUpload.value = !isShowFileUpload.value;
};

const handleShowFileUpload = () => {
  if (isShowFileUpload.value) {
    isShowUnsavedChangesModal.value = true;
  } else {
    isShowFileUpload.value = true;
  }
};

// Отображение модального окна подтверждения сохранения изменений
const isShowUnsavedChangesModal = ref(false);
const showUnsavedChangesModal = () => {
  isShowUnsavedChangesModal.value = true;
};

const hideUnsavedChangesModal = () => {
  isShowUnsavedChangesModal.value = false;
};

const handleShowUnsavedChangesModal = () => {
  isShowUnsavedChangesModal.value = false;
  isShowFileUpload.value = false;
};

// Модальное окно выхода из системы
const isShowLogoutModal = ref(false);
const showLogoutModal = () => {
  isShowLogoutModal.value = true;
};
const hideLogoutModal = () => {
  isShowLogoutModal.value = false;
};

// Выход из системы.
const doLogout = async () => {
  await exit();
};

// Меню при клике на пользователя
const isShowUserMenu = ref(false);

const toggleUserMenu = () => {
  isShowUserMenu.value = !isShowUserMenu.value;
};

const closeUserMenu = () => {
  isShowUserMenu.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_ButtonIconAccentPrimary = _resolveComponent("ButtonIconAccentPrimary")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconLogo)
    ]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuRouterList, (menuItem) => {
        return _withDirectives(_createElementVNode("button", {
          key: menuItem.name,
          class: _normalizeClass(["sidebar__nav-button", {'sidebar__nav-button--active': activeRouterPath.value === '/' + menuItem.path}]),
          onClick: ($event: any) => (changeRouteHandler(menuItem.path))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(menuItem.icon)))
        ], 10, _hoisted_4), [
          [_directive_tooltip, menuItem.tooltip, "right:16"]
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createBlock(_component_ButtonIconAccentPrimary, {
        class: "sidebar__action-button",
        onClick: handleShowFileUpload
      }, {
        default: _withCtx(() => [
          _createVNode(IconPlus)
        ]),
        _: 1
      })), [
        [_directive_tooltip, 'Загрузить данные', "right:17"]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "sidebar__user-button",
          onClick: toggleUserMenu
        }, [
          _createVNode(IconUser)
        ]),
        (isShowUserMenu.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              _createElementVNode("li", {
                class: "sidebar__user-item",
                onClick: showLogoutModal
              }, [
                _createVNode(IconLogout),
                _cache[0] || (_cache[0] = _createTextVNode(" Выход ", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_click_outside, closeUserMenu]
      ])
    ]),
    (isShowLogoutModal.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          "confirm-text": "Выйти",
          "cancel-text": "Отмена",
          title: "Выход из аккаунта",
          teleport: "#app",
          onConfirm: doLogout,
          onCancel: hideLogoutModal
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Уверены, что хотите выйти? ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isShowFileUpload.value)
      ? (_openBlock(), _createBlock(FilesUploadModal, {
          key: 1,
          onToggleShow: toggleShowFileUpload,
          onShowUnsavedChanges: showUnsavedChangesModal
        }))
      : _createCommentVNode("", true),
    (isShowUnsavedChangesModal.value && isShowFileUpload.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          teleport: "#app",
          title: "Данные не сохранились",
          "confirm-text": "Закрыть",
          onCancel: hideUnsavedChangesModal,
          onConfirm: handleShowUnsavedChangesModal
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Данные не загружены. Уверены, что хотите закрыть окно загрузки? ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isShowFileUpload.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})